import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ExtTaxaAdmService } from 'src/app/services/extTaxaAdm.service';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-ext-taxa-adm',
    templateUrl: './ext-taxa-adm.component.html',
    styleUrls: ['./ext-taxa-adm.component.css'],
    imports: [CommonModule, ReactiveFormsModule, NgxPaginationModule]
})
export class ExtTaxaAdmComponent implements OnInit {

  public dados:any[] = [];
  public anoMes:any[] = [];
  public tiposFundos:any[] = [];
  public formFiltro: FormGroup = null;
  paginaAtual : number = 1 ;
  qntPorPage : number = 10;

  constructor(private extTaxaAdmService: ExtTaxaAdmService) { }

  ngOnInit() {
    
    this.formFiltro = new FormGroup({
      anomesInicio:new FormControl(0),
      anomesFim: new FormControl(0),
      tipoFundo: new FormControl(0),
      tipoOrdem: new FormControl(0),
    });

    this.ListarFiltro();
    this.Listar();
  }

  public ListarFiltro(){
    
    this.extTaxaAdmService.AnoMes()
    .subscribe(
      (res: any[])=> {
        this.anoMes = res;
      },
      (error: HttpErrorResponse) => {
        console.error(error);
      }
    )
  }

  public Listar(){

    this.paginaAtual = 1;
    let anomesInicio = this.formFiltro.get("anomesInicio").value;
    let anomesFim = this.formFiltro.get("anomesFim").value;
    
    this.extTaxaAdmService.Listar(anomesInicio, anomesFim)
    .subscribe(
      (res:any)=> {
        this.dados = res;
      },
      (error: HttpErrorResponse) => {
        console.error(error);
      }
    )
  }

  print() {
    window.print();
  }
}
